<template>
  <el-dialog :visible.sync="showDetailDialog" :title="dialogTitle" width="65%">
    <div style="width: 100%; height: 100%" class="management_dialog">
      <el-select
        v-model="value"
        placeholder="请选择"
        :disabled="disabled"
        @change="selectYear"
        class="management_dialog-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        class="infor_tabs"
        type="card"
      >
        <el-tab-pane label="申报信息" name="theFourth">
           <el-row class="inform_title">
            <span class="title_name">申报项目信息</span>
          </el-row>
          <el-row class="inform_title">
            <div style="display: flex;justify-content: space-between;padding-right: 100px;">
              <span>发布标题：{{enterpriseDemonstrate.titile}}</span>
              <span>项目名称：{{enterpriseDemonstrate.pjConfigName}}</span>
            </div>
          </el-row>
           <el-row class="inform_title">
            <span>申报要求： {{ enterpriseDemonstrate.applyAsk }}</span>
          </el-row>
          <el-row class="inform_title">
            <span>申报分类： {{ enterpriseDemonstrate.contentClassName }}</span>
          </el-row>
          <!-- <el-table
            :data="eportList"
            style="width: 98%"
            highlight-current-row
          >

            <el-table-column
              prop="year"
              label="年份"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="上报情况"
              min-width="20"
              align="center"
            >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.reportStatus==2">已完善</el-tag>
              <el-tag type="info" v-if="scope.row.reportStatus==3">未提交</el-tag>
              <el-tag type="warning" v-if="scope.row.reportStatus==1">未完善</el-tag>
             <el-tag type="success" v-if="scope.row.reportStatus==4">已提交</el-tag>
            </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="操作"
              min-width="20"
              align="center"
            >
            <template slot-scope="scope">
              <el-button :disabled='scope.row.reportStatus==1?true:false' @click="handleClickyear(scope.row)" type="text" size="small">查看</el-button>
            </template>
            </el-table-column>
          </el-table> -->
          <el-row class="inform_title">
            <span class="title_name">上报信息</span>
          </el-row>
          <el-row class="inform_title">
            <span>申报说明： {{ enterpriseDemonstrate.commitContent }}</span>
          </el-row>
          <el-row class="inform_title" type="flex" :align="'top'">
            <span>申报材料：</span>
            <span class="detail_content-row-images">
              <span
                v-for="(item, key) in enterpriseDemonstrate.recordFileList"
              >
                <!-- <img :src="item.url" alt="" /> -->
                <el-image
                  :src="urlImg+item.fileUrl"
                  :preview-src-list='[urlImg+item.fileUrl]'
                  :key="key"
                  style="width: 200px"
                >
                </el-image>
              </span>
              <span
                class="allThe"
                v-if="
                  showState(enterpriseDemonstrate.recordFileList)
                "
              >
                暂无图片
            </span>
            </span>
          </el-row>
          <el-row class="inform_title">
            <span class="title_name">申请进度</span>
          </el-row>
        <el-row style="padding-bottom: 20px" class="inform_title">
          <div style="margin: 12px 0">
            当前状态：
            <span v-if="enterpriseDemonstrate.status==1">审核通过</span>
            <span v-if="enterpriseDemonstrate.status==2">已创建</span>
            <span v-if="enterpriseDemonstrate.status==3">待初审</span>
            <span v-if="enterpriseDemonstrate.status==4">待复审</span>
            <span v-if="enterpriseDemonstrate.status==5">驳回</span>
          </div>
          <div class="record" v-for="(item,index) in rateList" :key="index">
            <div class="record_box">
              <div style="color: red;padding-right: 12px;" v-if="item.status==5"><i class="el-icon-circle-close"></i></div>
                <div style="color: #0abe77;padding-right: 12px;"  v-else>
                <i class="el-icon-success" ></i>
              </div>
              <div>{{GLOBAL.timetoDate(item.createTime)}} || {{item.content}}:
                <span v-if="item.checkStatus==1">已通过</span>
                <span v-if="item.checkStatus==2">驳回</span>
                <span v-if="item.checkStatus==3">成功</span>
                ||<span v-if="item.checkStatus==2">驳回原因:{{item.remark}}||</span>  操作人:{{item.operator}}</div>
            </div>
        </div>
      </el-row>
          <div>
            <div
             v-if="enterpriseDemonstrate.status==1 && canRevoke"
              slot="footer"
              class="dialog-footer"
              style="text-align: center; padding-top: 20px;"
            >
              <el-button size="small" type="primary" @click="refreshDialog"
                >撤销通过</el-button
              >
            </div>
            <!-- 提交申请成功 -->
            <div v-else>
               <div
               v-if="(enterpriseDemonstrate.status==3 && canFirstCheck) || enterpriseDemonstrate.status==4 && canSecondCheck"
                slot="footer"
                class="dialog-footer"
                style="text-align: center;padding-top: 20px;"
              >
                <el-button size="small" type="primary" @click="adoptFn"
                  >通 过</el-button
                >
                <el-button size="small" type="primary" @click="rejectFn"
                  >驳回</el-button
                >
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="基本信息" name="demonstration">
          <div style="width: 100%; height: 100%" class="operator_dialog">
            <el-row class="inform_title">
              <span class="title_name">基础信息</span>
            </el-row>
            <el-row :gutter="20" class="info-detail">
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>主体类型：</span
                  ><span>{{ spaceDetail.enterpriseTypeName }}</span>
                </div>
                <div class="info-detail-block">
                  <span>经营类型：</span
                  ><span>{{ spaceDetail.industryDicName }}</span>
                </div>
                <div class="info-detail-block">
                  <span>证件号码：</span
                  ><span>{{ spaceDetail.unifiedSocialCreditCode }}</span>
                </div>
                <div class="info-detail-block">
                  <span>主体位置：</span><span>{{ spaceDetail.qhmc }}</span
                  ><img
                    @click="openMap"
                    src="../../../static/img/location.svg"
                    class="location-svg"
                    alt=""
                  />
                </div>
                <div class="info-detail-block">
                  <span>注册地址：</span><span>{{ spaceDetail.address }}</span>
                </div>
                <div class="info-detail-block">
                  <span>注册资金：</span
                  ><span>{{ spaceDetail.registerCapital }}万元</span>
                </div>
                <div class="info-detail-block">
                  <span>成立日期：</span
                  ><span>{{ formatterDate(spaceDetail.createDate) }}</span>
                </div>
                 <div class="info-detail-block">
                    <span>联系人姓名：</span
                    ><span>{{ spaceDetail.contacts }}</span>
                  </div>
                  <div class="info-detail-block">
                    <span>联系人手机号：</span
                    ><span>{{spaceDetail.mobile }}</span>
                  </div>
              </el-col>
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>主体等级：</span
                  ><span>{{ spaceDetail.gradeName }}</span>
                </div>

                <div class="info-detail-block">
                  <span>证件照片：</span>
                  <div>
                   <span v-if="qualificationImg.length!=0">
                      <el-image
                      class="info-detail-block-license"
                       v-for="(item,index) in qualificationImg" :key="index"
                      :src="item.url"
                      alt=""
                      :preview-src-list="[item.url]"
                    >
                    </el-image>
                   </span>
                    <span v-else>暂无图片</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row class="inform_title">
              <span class="title_name">人员信息</span>
            </el-row>
            <el-row :gutter="20" class="info-detail">
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>法人姓名：</span><span>{{ spaceDetail.corporationName }}</span>
                </div>
                <div class="info-detail-block">
                  <span>法人证件号码：</span
                  ><span>{{ spaceDetail.corporationCardId }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>法人手机号：</span><span>{{ spaceDetail.corporationMobile }}</span>
                </div>
              </el-col>
            </el-row>
            <div
              class="info-detail-block"
              style="padding-left: 10px; display: flex"
            >
              <span>法人证件照片：</span>
              <div class="info-detail-block-img">
                <el-image
                  style="width: 100%"
                  :src="
                    spaceDetail.corporationCardFrontUrl
                      ? spaceDetail.corporationCardFrontUrl
                      : ''
                  "
                  :preview-src-list="[spaceDetail.corporationCardFrontUrl]"
                  v-if="
                    spaceDetail.corporationCardFrontUrl &&
                    spaceDetail.corporationCardFrontUrl
                  "
                >
                </el-image>
                <span v-else>暂无图片</span>
              </div>
              <div class="info-detail-block-img">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="
                    spaceDetail.corporationCardBackUrl
                      ? spaceDetail.corporationCardBackUrl
                      : ''
                  "
                  v-if="
                    spaceDetail.corporationCardBackUrl &&
                    spaceDetail.corporationCardBackUrl
                  "
                  :preview-src-list="[spaceDetail.corporationCardBackUrl]"
                >
                </el-image>
                <span v-else>暂无图片</span>
              </div>
            </div>
            <el-row class="inform_title">
              <span class="title_name">其他信息</span>
            </el-row>
            <el-row :gutter="20" class="info-detail">
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>是否加入联合社：</span
                  ><span>{{
                    spaceDetail.isUnionOrganization === 1 ? "是" : "否"
                  }}</span>
                </div>
                <div class="info-detail-block">
                  <span>开户账号：</span
                  ><span>{{ spaceDetail.bankNumber }}</span>
                </div>
                <div class="info-detail-block">
                  <span>开户许可证： </span>
                  <el-image
                    class="info-detail-block-license"
                    :src="licenseImg"
                    alt=""
                    v-if="licenseImg"
                    :preview-src-list="[licenseImg]"
                  >
                  </el-image>
                  <span v-else>暂无图片</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-detail-block">
                  <span>开户银行：</span><span>{{ spaceDetail.bankName }}</span>
                </div>
                <div class="info-detail-block" style="justify-content: flex-start;">
                  <span style="width: 28%;">主体简介：</span
                  ><span style="width: 100%;">{{ spaceDetail.description }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ifRejected" class="detail_item" :gutter="20">
              <div class="detail_name">
                驳回意见：<span>{{ spaceDetail.refuseReason }}</span>
              </div>
            </el-row>
          </div>
          <mapLog ref="mapLog"></mapLog>
        </el-tab-pane>
        <el-tab-pane label="年度上报" name="first">
          <el-row class="inform_title">
            <span class="title_name">经营范围</span>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <!-- <div class="detail_name">从事行业：</div> -->
            <div class="detail_content">
              <el-row
                :gutter="20"
                class="detail_content-row"
                v-for="(
                  item, key
                ) in currentEnterprise.enterpriseManageItemVoList"
                :key="key"
              >
                <el-col :span="6" class="space-top"
                  ><div>{{ item.name }}</div></el-col
                >
                <el-col
                  :span="6"
                  class="space-top"
                  v-for="(t, k) in item.enterpriseManageItemList"
                  :key="k"
                  ><div>
                    <span>{{ t.key }}</span
                    >：<span>{{ t.value ? t.value : 0 }}</span>
                    <span> {{ t.unit }}</span>
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
          <el-row class="inform_title">
            <span class="title_name">组织成员</span>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_name">组织情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="6"
                  ><div>
                    理事会：{{
                      currentEnterprise.enterpriseMember.directorCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    监事会：{{
                      currentEnterprise.enterpriseMember.supervisorCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    是否建立党支部：{{
                      filterType(
                        currentEnterprise.enterpriseMember.isCreatePartyBranch
                      )
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    其中党员人数：{{
                      currentEnterprise.enterpriseMember.partyMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_name">成员情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
              >
              <el-col :span="24"
                  ><div>
                    实有成员总数：{{
                      currentEnterprise.enterpriseMember.realMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="6"
                  ><div>
                    其中普通农户：{{
                      currentEnterprise.enterpriseMember.farmerCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    其中家庭农场成员：{{
                      currentEnterprise.enterpriseMember.familyMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    其中企业成员：{{
                      currentEnterprise.enterpriseMember.enterpriseMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    其中其他成员：{{
                      currentEnterprise.enterpriseMember.otherMemberCount
                        | formatting("人")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-table
                :data="EnterpriseMemberMessageList"
                style="width: 98%"
                highlight-current-row
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="jobName"
                  label="职务"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="mobile"
                  label="联系方式"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberIdentityName"
                  label="成员身份"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="isPartyMember"
                  label="是否公共党员"
                  min-width="20"
                  align="center"
                  :formatter="formatterTypeFn"
                >
                </el-table-column>
                <el-table-column
                  prop="contributionMoney"
                  label="出资额(万元)"
                  min-width="20"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-row>
          <el-row class="inform_title">
            <span class="title_name">财务状况</span>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_name">资产及土地情况：</div>
            <div class="detail_content">
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="6"
                  ><div>
                    资产总额：{{
                      currentEnterprise.enterpriseAssetsLand.assetsMoney
                        | formatting("万元")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    固定资产净值：{{
                      currentEnterprise.enterpriseAssetsLand.fixedAssetsMoney
                        | formatting("万元")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    总负债额：{{
                      currentEnterprise.enterpriseAssetsLand.totalLiabilities
                        | formatting("万元")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    所有者权益：{{
                      currentEnterprise.enterpriseAssetsLand.ownerAssets
                        | formatting("万元")
                    }}
                  </div></el-col
                >
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                class="detail_content-row"
              >
                <el-col :span="6"
                  ><div>
                    土地总面积：{{
                      currentEnterprise.enterpriseAssetsLand.landArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    土地经营权入股土地：{{
                      currentEnterprise.enterpriseAssetsLand.tdljyqLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    流转土地：{{
                      currentEnterprise.enterpriseAssetsLand.outLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    其他土地：{{
                      currentEnterprise.enterpriseAssetsLand.otherLandArea
                        | formatting("亩")
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_name">收益及分配情况：</div>
            <div class="detail_content">
              <div class="detail_content-views">
                <div class="detail_content-views--block">
                  <h3>收益情况</h3>
                  <div class="boldView">
                    总收入：{{
                      currentEnterprise.enterpriseProfitAssignment.totalIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    其中年经营收入：{{
                      currentEnterprise.enterpriseProfitAssignment.yearIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    总支出：{{
                      currentEnterprise.enterpriseProfitAssignment.totalPay
                        | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    上年为分配盈余：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .lastYearSurplus | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    总盈余：{{
                      currentEnterprise.enterpriseProfitAssignment.totalSurplus
                        | formatting("万元")
                    }}
                  </div>
                </div>
                <div class="detail_content-views--block">
                  <h3>分配情况</h3>
                  <div class="boldView">
                    年底分红总额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .yearEndObtainMoney | formatting("万元")
                    }}
                  </div>
                  <div class="fineView">
                    其中农民成员分红金额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .farmerObtainMoney | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    统一购买生产资料总额：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .productionDataMoney | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    相对于散户优惠百分比：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .productionDiscountPercentage | formatting("%")
                    }}
                  </div>
                  <div class="boldView">
                    统一组织销售农产品总额：{{
                      currentEnterprise.enterpriseProfitAssignment.saleMoney
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    相对于散户优惠百分比：{{
                      currentEnterprise.enterpriseProfitAssignment
                        .saleDiscountPercentage | formatting("%")
                    }}
                  </div>
                </div>
                <div class="detail_content-views--block">
                  <h3>其他情况</h3>
                  <div class="boldView">
                    成员社内年平均所得收入：{{
                      currentEnterprise.enterpriseProfitAssignment.averageIncome
                        | formatting("万元")
                    }}
                  </div>
                  <div class="boldView">
                    财政直接补助财产是否平均量化到成员：{{
                      filterType(
                        currentEnterprise.enterpriseProfitAssignment
                          .subsidyIsAverage
                      )
                    }}
                  </div>
                  <div class="boldView">
                    公积金是否按章程规定量化到成员：{{
                      filterType(
                        currentEnterprise.enterpriseProfitAssignment
                          .accumulationFundIsAverage
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>年度资产负债表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in assetsLiabilitie"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                           assetsLiabilitie
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                  <div class="half">
                    <div>盈余分配表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in surplustList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            surplustList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>成员权益变动表</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in interests"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(interests)
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
          <el-row class="inform_title">
            <span class="title_name">贷款状况</span>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                今年是否贷款：{{
                  loanType(currentEnterprise.enterpriseLoan.isLoan)
                }}
              </div>
              <div class="detail_content-row">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="width: 45%; float: left"
                >
                  <el-col :span="6">
                    <div>贷款实际情况：</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款金额</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanMoney
                          | formatting("万元")
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款银行</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanBank | formatting
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款利率</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.interestRate
                          | formatting("%")
                      }}
                    </div>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="width: 45%; float: right"
                >
                  <el-col :span="6">
                    <div>贷款意向：</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款金额</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.planLoanMoney
                          | formatting("万元")
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款期限</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanTerm | formatting
                      }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="detail_content-row-top">贷款用途</div>
                    <div>
                      {{
                        currentEnterprise.enterpriseLoan.loanPurpose
                          | formatting
                      }}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="其他信息" name="second">
          <el-row class="inform_title">
            <span class="title_name">制度章程</span>
          </el-row>
          <el-row class="detail_item" :gutter="20">
            <div class="detail_content">
              <div class="detail_content-row">
                <div class="detail_content-space">
                  <div class="half">
                    <div>合作社章程</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .cooperativeCharterImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                         <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.cooperativeCharterImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                  <div class="half">
                    <div>质量管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .qualityAssuranceImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.qualityAssuranceImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>质量安全追溯制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .qualitySafetyImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(otherDetails.imgList.qualitySafetyImgList)
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                  <div class="half">
                    <div>生产记录档案制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .styleDicNumbersImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(otherDetails.imgList.styleDicNumbersImgList)
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detail_content-space">
                  <div class="half">
                    <div>材料管理制度</div>
                    <div class="detail_content-row-images">
                      <div
                        v-for="(item, key) in otherDetails.imgList
                          .materialManagementImgList"
                        :key="key"
                      >
                        <!-- <img :src="item.url" alt="" /> -->
                        <el-image
                          :src="item.url"
                          :preview-src-list='[item.url]'>
                        </el-image>
                      </div>
                      <div
                        class="allThe"
                        v-if="
                          showState(
                            otherDetails.imgList.materialManagementImgList
                          )
                        "
                      >
                        暂无图片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
          <el-row class="inform_title">
            <span class="title_name">运行绩效</span>
          </el-row>
          <h3>参与政府项目</h3>
          <el-table
            :data="enterpriseGovernmentWorkList"
            style="width: 98%"
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="particularYear"
              label="年份"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="subsidyName"
              label="项目名称"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="subsidyMoney"
              label="补助金额(万元)"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="subsidyMoneyIsReceived"
              label="补助款是否到账"
              min-width="20"
              align="center"
              :formatter="formatterTypeFn"
            >
            </el-table-column>
          </el-table>
          <el-row class="inform_title">
            <span class="title_name">社会贡献</span>
          </el-row>
          <el-table
            :data="societyContributVoList"
            style="width: 98%"
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="year"
              label="年份"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="类别"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="20"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="describe"
              label="描述"
              min-width="20"
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-row class="inform_title">
            <span class="title_name">荣誉资质</span>
          </el-row>
          <el-row type="flex" class="qualification-view qualification">
            <el-col :span="14"
              ><div class="left-space">荣誉资质类别</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              个数(个/枚)</el-col
            >
            <el-col :span="5"><div class="center-space">附件</div></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有注册商标数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.brandCount | formatting("枚")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'brandCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.brandCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"><div class="left-space">拥有专利数</div></el-col>
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.patentCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'patentCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.patentCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有绿色食品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.greenFoodCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'greenFoodCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.greenFoodCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有有机产品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.organiProductCount
                  | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'organiProductCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.organiProductCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有地理标志产品认证数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.geographyProductCount
                  | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'geographyProductCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo
                        .geographyProductCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">拥有食品生产许可证（CS）数</div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.csNcount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'csNcountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.csNcountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"
              ><div class="left-space">
                通过ISO9000,HACCP等质量认证情况
              </div></el-col
            >
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                filterType(otherDetails.enterpriseHonorVo.isIsoHaccp)
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, '--')"
                  :preview-src-list="[]"
                >
                </el-image></div
            ></el-col>
          </el-row>
          <el-row type="flex" class="qualification-view">
            <el-col :span="14"><div class="left-space">其他</div></el-col>
            <el-col :span="5"
              ><div class="center-space"></div>
              {{
                otherDetails.enterpriseHonorVo.otherCount | formatting("个")
              }}</el-col
            >
            <el-col :span="5"
              ><div class="center-space">
                <el-image
                  :src="showIcon(otherDetails, 'otherCountImgList')"
                  :preview-src-list="
                    filterImgList(
                      otherDetails.enterpriseHonorVo.otherCountImgList
                    )
                  "
                >
                </el-image></div
            ></el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync="DetailDialog" append-to-body :title="dialogTitle" width="35%" @opened="dialogOpened">
      <el-row iv  v-if="adopt==false" ref="rejectFrom" type="flex" :align="'top'" class="row-wrap">
        <!-- <el-form-item label="驳回原因" prop="textarea" > -->
          <span class="label"><span style="color:red;" class="xrequired"> </span>驳回原因 </span>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入驳回原因"
            v-model="textarea"
            style="width:80%"
          >
          </el-input>
        <!-- </el-form-item> -->
        </el-row>
      <h3 v-else style="text-align: center;">确定该主体满足项目申报条件？</h3>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="determine"
          >确 定</el-button>
        <el-button size="small" plain type="primary" @click="DetailDialog = false"
          >取 消</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import API from "@/api/serviceOrgManagement/api_userManagement";
import API_CONFIG from "@/api/api_project/api_project";
import Cookies from "js-cookie";
import mapLog from "./mapLog.vue";
export default {
  components: { mapLog },
  name: "operatorDialog",
  props: ["ifAudit", "ifRejected"],
  data() {
    return {
      urlImg:'https://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/',
      currentEnterprise: {
        enterpriseProfitAssignment: {},
        enterpriseLoan: {},
        EnterpriseMemberMessageList: {},
        enterpriseMember: {},
        enterpriseAssetsLand: {},
        enterpriseManageItemVoList: [],
      }, //当前项字段
      otherDetails: {
        imgList: [],
        enterpriseHonorVo: {},
      }, // 其他项
      showDetailDialog: false,
      DetailDialog:false,
      activeName: "theFourth",
      options: [
         {
          value: "2017",
          label: "2017",
        },
         {
          value: "2018",
          label: "2018",
        },
         {
          value: "2019",
          label: "2019",
        },
        {
          value: "2020",
          label: "2020",
        },
         {
          value: "2021",
          label: "2021",
        },
        {
          value: "2022",
          label: "2022",
        },
      ],
      value: "2020",
      dialogTitle: "",
      textarea:"",
      EnterpriseMemberMessageList: [], //组织成员情况 列表
      enterpriseGovernmentWorkList: [], // 参与政府项目
      societyContributVoList: [], // 社会贡献
      enterpriseNumber: "", //编号
      spaceDetail: {},//基本信息数据
      enterpriseDemonstrate:{},//示范申请详情
      ruleForm: {
        rejectContent: "",
      },
      qualificationImg: [], //主体资格证明图片
      licenseImg: "", //许可证图片
      ifShowReject: false,
      disabled:true,
      adopt:false,
      rateList:[],//日志
      description:"",//初审
      clubNumber:'',//示范社编码
      status:'',//申请状态
      assetsLiabilitie:[],
      surplustList:[],
      interests:[],
      // 是否可以撤销通过
      canRevoke: false,
      showDisableds:false,
      // 可初审
      canFirstCheck: false,
      // 可复审
      canSecondCheck: false,
      rules: {
        rejectContent: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    formatting(val, unit) {
      if (!val) {
        if (!unit) {
          return "--";
        }
        return 0 + unit;
      } else {
        return val + (unit ? unit : "");
      }
    },
  },
  computed: {
    disabled() {
      return this.activeName !== "first";
    },
  },
  methods: {
    chooseRoleCode() {
      let roleList = localStorage.getItem('roleList')

      if(roleList) {
        roleList = JSON.parse(roleList)

        roleList.forEach(item => {
          if(item.roleCode == process.env.shij_manger) {
            this.canRevoke = true
            this.canSecondCheck = true
          } else if(item.roleCode== process.env.xianj_manger){
            this.canFirstCheck = true
          } else {
            this.canFirstCheck = false
            this.canRevoke = false
            this.canSecondCheck = false
          }
        });
      }

    },
    // 年份筛选
    selectYear(val) {
      this.value=val
      this.manageDetail()
      // console.log(val)
    },
    showState(list) {
      if (list && list.length) {
        return false;
      }
      return true;
    },
    filterImgList(imgList) {
      // 过滤图片
      if (imgList && imgList.length) {
        let list = [];
        imgList.forEach((item) => {
          list.push(item.url);
        });
        return list;
      }
      return [];
    },
    showIcon(current, list) {
      if (
        current.enterpriseHonorVo &&
        current.enterpriseHonorVo[list] &&
        current.enterpriseHonorVo[list].length
      ) {
        return require("../../../static/img/attachment.png");
      } else {
        return require("../../../static/img/ashAttachment.png");
      }
    },
    loanType(val) {
      if (val === 2) {
        return "否";
      } else if (val === 1) {
        return "是";
      }
      return "--";
    },
    filterType(val) {
      if (val === 0) {
        return "否";
      } else if (val === 1) {
        return "是";
      }
      return "--";
    },
    formatterFn(row, column, cellValue, index) {
      if (cellValue === 2) {
        return "否";
      } else if (cellValue === 1) {
        return "是";
      }
      return "--";
    },
    formatterTypeFn(row, column, cellValue, index) {
      if (cellValue === 0) {
        return "否";
      } else if (cellValue === 1) {
        return "是";
      }
      return "--";
    },
    // 打开详情弹窗
    dialogOpen(row) {
      this.showDetailDialog = true;
      this.currentEnterprise.enterpriseProfitAssignment = {};
      this.currentEnterprise.enterpriseLoan = {};
      this.currentEnterprise.enterpriseMember = {};
      this.currentEnterprise.enterpriseAssetsLand = {};
      this.currentEnterprise.enterpriseManageItemVoList = [];
      this.EnterpriseMemberMessageList = []; //组织成员情况 列表
      this.enterpriseGovernmentWorkList = []; // 参与政府项目
      this.societyContributVoList = []; // 社会贡献
      this.dialogTitle = row.enterpriseName;
      this.status=row.status
      this.activeName = "theFourth";
      this.enterpriseNumber = row.enterpriseNumber;
      this.manageDetail(this.enterpriseNumber);
      this.restDetail(this.enterpriseNumber);
      this.spaceDetail = {};
      this.number = row.enterpriseNumber;
      this.clubNumber=row.id
      this.priseDetail(row.enterpriseNumber);
      this.getmanagereportList()
      this.getdemonstrateList(row)
      this.getdemonstrationDetail(row.id)
      this.chooseRoleCode()

    },
    dialogOpened() {
      this.textarea = ''
      // if(this.$refs.rejectFrom) {
      //   this.$refs.rejectFrom.clearValidate()
      // }
    },
    handleClick(tab, event) {
       if(this.activeName=='first'){
        this.disabled=false
      }else{
        this.disabled=true
      }
    },

    // 查询当前打开项
    async manageDetail(enterpriseNumber) {
      const { code, data, msg } = await API.manageDetail({
        enterpriseNumber: enterpriseNumber||this.number,
        year: this.value,
      });
      if (code === 0) {
        this.currentEnterprise = data;
        this.EnterpriseMemberMessageList = data.EnterpriseMemberMessageList; //组织成员列表
        // 3:年度资产负债，4：盈余分配表，5：成员权益变动表
        this.assetsLiabilitie=[]
        this.surplustList=[]
        this.interests=[]
        if(data.financeImgList.length!=0){
          data.financeImgList.map(item=>{
            if(item.type==3){
                this.assetsLiabilitie.push(item)
            }else if(item.type==4){
                this.surplustList.push(item)
            }else{
              this.interests.push(item)
            }
          })

        }
      } else {
       this.currentEnterprise={
        enterpriseProfitAssignment: {},
        enterpriseLoan: {},
        EnterpriseMemberMessageList: {},
        enterpriseMember: {},
        enterpriseAssetsLand: {},
        enterpriseManageItemVoList: [],
      },
      this.EnterpriseMemberMessageList =[]
        this.GLOBAL.error(msg);
      }
    },
    async restDetail(enterpriseNumber) {
      const { code, data } = await API.restDetail({
        enterpriseNumber,
      });
      if (code === 0) {
        this.otherDetails = data;
        this.enterpriseGovernmentWorkList = data.enterpriseGovernmentWorkList;
        this.societyContributVoList = data.societyContributVoList;
      } else {
        this.GLOBAL.error(msg);
      }
    },
    //示范申请
   async  getdemonstrationDetail(number){
      const { code, data } = await API_CONFIG.getRecordDetail({
          id:number,
        });
        if(code==0){
            this.enterpriseDemonstrate = data;
        }
    },
    //年度上报
   async  getmanagereportList(){
      const {code,msg,data} =await API.managereportList({enterpriseNumber:this.number})
      if(code==0){
        this.eportList=data.list
      }

    },
    //操作日志
    async getdemonstrateList(row){
    const { code, data } = await API_CONFIG.getRecordLog({
      enterpriseNumber: row.enterpriseNumber,
      pjConfigId: row.pjConfigId,
      pjInformationId: row.pjInformationId
    });
      if(code==0){
        this.rateList=data.list
      }
    },
    rejectFn(){
      this.DetailDialog=true
      this.Title = "驳回理由";
      this.textarea = ''
      this.status=3
      this.adopt=false
    },
    // 产看年度
    handleClickyear(row){
      this.activeName='first'
      this.value=row.year
       this.manageDetail()

    },
      /**通过弹窗 */
    adoptFn() {
      console.log("this.status",this.status)
      this.DetailDialog=true
      this.Title = "提示";
      this.textarea = ''
      this.adopt=true
    },
     // 驳回||通过确认按钮
    determine(){
      let status = ''

      if (this.canFirstCheck) {
        status = 4
      } else if (this.canSecondCheck) {
        status = 1
      }

      if(this.adopt==true){
          this.demonstrationSocietyUpdateStatus({
            id:this.clubNumber,
            status,
            refuseReason:''
          })
      }else{
        if(this.textarea==false){
           this.$message({
            message: '驳回原因不能为空',
            type: 'warning'
          });
          return
        }
         this.demonstrationSocietyUpdateStatus({
          id:this.clubNumber,
          status: 5,
          refuseReason:this.textarea
        })
      }
      //  if(this.status==1){
      //   this.status=1
      // }else if(this.status==4){
      //   this.status=2
      // }
    },
      //驳回同意接口
    async demonstrationSocietyUpdateStatus(val) {
      let { code, data,msg } = await API_CONFIG.recordCheck(val);
      if (code === 0) {
          this.$message({
          message: this.adopt==true?'通过操作成功':'驳回操作成功',
          type: 'success'
        });
        this.DetailDialog = false;
        this.showDetailDialog = false;
        this.textarea=''
        this.$emit("tableRefresh");

      }else{
            this.$message({
                message:msg,
                type: 'warning'
           });
      }
    },
     // 打开地图定位
    openMap() {
      if (!this.spaceDetail.lgd) return this.GLOBAL.error("无当前主体定位");
      let lnglat = [this.spaceDetail.lgd, this.spaceDetail.ltd];
      // let lnglat = [110.934521014286, 31.8761197179647];
      this.$refs.mapLog.dialogOpen(lnglat);
    },
    // 查询当前打开项
    async priseDetail(number) {
      const { code, data, msg } = await API.priseDetail({ number });
      if (code === 0) {
        this.spaceDetail = data.UnauditedList;
        this.qualificationImg=[]
        this.spaceDetail.enterpriseImgList.forEach((item) => {
          if (item.type === 1) {
            this.qualificationImg.push(item)
          } else if (item.type === 4) {
            this.licenseImg = item.url;
          }if(item.type == 11){
             this.qualificationImg.push(item);
          }
        });
         let headurl= this.spaceDetail.corporationCardFrontUrl ? this.spaceDetail.corporationCardFrontUrl.substr(0,4) : ''
         let headurlBack=this.spaceDetail.corporationCardBackUrl ? this.spaceDetail.corporationCardBackUrl.substr(0,4) : ''

         console.log('headurlBack', headurlBack)
          if(headurl!='http'){
            this.spaceDetail.corporationCardFrontUrl='http://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/'+this.spaceDetail.corporationCardFrontUrl
          }
          if(headurlBack!='http'){
            this.spaceDetail.corporationCardBackUrl='http://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/'+this.spaceDetail.corporationCardBackUrl
          }
      } else {
        this.GLOBAL.error(msg);
      }
    },
      formatterDate(cellValue) {
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Number(cellValue), "date");
    },
    //取消评级
    refreshDialog(){
      this.$prompt('请输入驳回理由', '驳回理由', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPattern: /\S/,
        inputErrorMessage: '驳回不能为空'
      }).then(async({ value }) => {

          const {code,msg,data}=await API_CONFIG.recordCheck({
            id: this.clubNumber,
            refuseReason:value,
            status: 5
          })
          if(code==0){
            this.$message({
              type: 'success',
              message: msg
            });
          }else{
            this.$message({
              type: 'info',
              message: msg
            });
          }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.row-wrap {
  & .label {
    display: inline-block;
    width: 100px;
    flex-shrink: 0;
    & .xrequired::before {
      content: '* ';
      color: red;
    }
  }
}
.qualification-view {
  padding: 13px 10px;
  width: 98%;
  .left-space {
    padding-left: 10px;
  }
  .center-space {
    text-align: center;
  }
}
.qualification {
  background: #f8f8f8;
  color: #909399;
  font-weight: bold;
}
.space-top {
  margin-top: 10px;
}
.management_dialog {
  .management_dialog-select {
    position: absolute;
    right: 10px;
    top: 77px;
    width: 90px;
    z-index: 1;
  }
  .detail_item {
    padding: 0 10px 0 20px;
    .detail_content-row {
      padding: 10px 0;
      .detail_content-space {
        display: flex;
        justify-content: space-between;
        .half {
          width: 47%;
          > div:nth-child(1) {
            margin-top: 10px;
          }
        }
      }
      .detail_content-row-images {
        // display: flex;
        padding: 10px;
        height: 102px;
        background: #f5f8fb;
        // justify-content: space-between;
        margin-top: 10px;
        display: -webkit-box;
        overflow: auto;
        .allThe {
          width: 100%;
        }
        div {
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32%;
          /deep/.el-image {
            height: 100% !important;
            width: 100%  !important;
          }
        }
      }
      .detail_content-row-top {
        width: 100%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        margin-top: -7px;
        background: #f5f8fb;
      }
      .detail_content-row-top + div {
        width: 100%;
        text-align: center;
        padding: 10px 0 0;
      }
    }
    .detail_name {
      color: #333333ff;
      font-weight: bold;
    }
    .detail_content-views {
      display: flex;
      justify-content: space-between;
      margin-top: 19px;
      .detail_content-views--block {
        width: 32%;
        background: #f5f8fb;
        height: 286px;
        .boldView {
          font-weight: bold;
          margin: 15px 0 0 20px;
        }
        .fineView {
          color: #d0d2cb;
          margin: 15px 0 0 30px;
        }
        h3 {
          text-align: center;
        }
      }
    }
  }
}
.operator_dialog {
  .textInput {
    width: 50%;
  }
  .basic_info {
    &:extend(.pinkrow);
    height: 40px;
    line-height: 40px;
    padding-right: 10px;
    background: #f4f4f4;
    color: grey;
  }
  .detail_item {
    padding-left: 20px;
  }
}
.info-detail {
  padding-left: 10px;
  .info-detail-block {
    padding-bottom: 15px;
    display: flex;
    .location-svg {
      height: 18px;
      width: 12px;
      margin-left: 10px;
      cursor: pointer;
    }
    .info-detail-block-license {
      width: 200px;
      margin-top: 5px;
      // height: 197px;
    }
    .info-detail-block-openImg {
      width: 200px;
      // width: 138px;
    }
  }
}
.info-detail-block-img {
  width: 247px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="less">
.table-Column {
  padding-left: 12px !important;
}
.management_dialog {
  .el-tabs__header .el-tabs__item.is-top.is-active {
    color: #fff !important;
    background: #0dc98e;
  }
  .el-tabs__item {
    color: #333333ff;
    background: #f5f5f8;
  }
  .el-tabs--card > .el-tabs__header {
    border: none;
    padding-left: 10px;
  }
  .el-tabs__header {
    box-shadow: none;
  }
  .el-table__header-wrapper .el-table__header th {
    background: #f8f8f8 !important;
  }
}
.record{
  // height: 30px;
  width: 98%;
  margin-top: 5px;
  line-height: 30px;
  border:  0.5px solid seagreen;
}
.record_box{
  display: flex;
  // justify-content: space-between;
  padding-right: 30px;
  padding-left: 30px;


}
</style>



// WEBPACK FOOTER //
// src/studio/manage/detailDialog.vue